import { axios, BaseApiUrl, BaseUrl } from "../axios_config";

///费用汇总表
export const GetFeeOrgDetailList = (params) => {
	return axios
		.post(`${BaseApiUrl}/FeeOrg/GetFeeOrgDetailList`, { ...params })
		.then((res) => res.data);
};

export const FeeOrgDetailExport = `${BaseApiUrl}/FeeOrg/FeeOrgDetailExport`;

export const FeeDepartmentExport = `${BaseApiUrl}/FeeOrg/FeeDepartmentExport`;

export const AddFeeDetail = (params) => {
	return axios.post(`${BaseApiUrl}/FeeOrg/AddFeeDetail`, params);
};
